import React, { useEffect, useState } from 'react';
import {useUser} from "../../../Services/userProvider";
import PrintComponent from "../../operateur_fret/frets/printer";
import {toast} from "react-toastify";
import ManifestAPI from "../../../apis/manifestApi/manifestAPI";
import Pagination from "../../assets/Pagination";
import TableLoader from "../../loaders/TableLoader";
import Moment from "moment/moment";
import MyButton from "../../assets/MyButton";

const ReceivedFret = () => {

    const user = useUser();

    const [total, setTotal] = useState("");
    const [dailyFrets, setDailyFrets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [setting, setSetting] = useState([]);
    const [showLoader, setShowLoader] = useState(false);

    const [vivo, setOutPutData] = useState([]);
    const [startAt, setStartAt] = useState("");
    const [endAt, setEndAt] = useState("");



    const fetchSetting = async () => {
        try{
            const data =  await ManifestAPI.findSetting();
            setSetting(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des paramettres !");
        }
    };

    const getDailyFrets = async () => {
        try{
            const data =  await ManifestAPI.dailyFretsForReception();
            setDailyFrets(data.frets);
            setOutPutData(data.frets);
            setTotal(data.total);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des frets du jours !");
        }
    };

    useEffect(() => {
        getDailyFrets();
        fetchSetting();
    },[]);

    const [busId, setBusId] = useState("");
    const [quantity, setQuantity] = useState("");

    const  handleDeliveryFret = async (itemId) => {

        try{

            setShowLoader(true);
            await ManifestAPI.deliverFret(itemId);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Le colis a été livré avec succès");
            window.location.reload();
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {message} = response.data;
            toast.error(message);
        }
    };


    //Gestion du changement de page
    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 1500;

    //Filtrage des buses en fonction de la recherche
    const filteredFrets = vivo.filter(
        b =>
            b.name.toLowerCase().includes(search.toLowerCase()) ||
            b.expediteur.toLowerCase().includes(search.toLowerCase()) ||
            b.code.toString().toLowerCase().includes(search.toLowerCase()) ||
            b.recipient.toLowerCase().includes(search.toLowerCase()) ||
            b.recipient_phone.toLowerCase().includes(search.toLowerCase()) ||
            b.expediteur_phone.toLowerCase().includes(search.toLowerCase()) ||
            b.city_to.toLowerCase().includes(search.toLowerCase())
            //|| b.bus_plaque.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedFrets = Pagination.getData(
        filteredFrets,
        currentPage,
        itemsPerPage
    );


    let counter = 1;

    function calculTotalFret(data) {
        let tCDF = 0;
        data.map((toto) =>  tCDF += toto.amount);
        return tCDF
    }

    function calculSubTotal(data) {
        let tCDF = 0;
        data.map((ticket) => tCDF += ticket.total_amount);
        return tCDF
    }

    const handleStartedDate = ({currentTarget}) => {
        setStartAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleEndedDate = ({currentTarget}) => {
        setEndAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleBtns = () => {

        if(startAt !== "" && endAt === "") {
            const filtered = dailyFrets.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") === Moment(startAt).format("YYYY/MM/DD"));
            setOutPutData(filtered);
        } else if (startAt !== "" && endAt !== "") {
            const filtered = dailyFrets.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD")
                    && Moment(item.created_at).format("YYYY/MM/DD") <= Moment(endAt).format("YYYY/MM/DD"));
            setOutPutData(filtered);
        }else{
            const filtered = dailyFrets.filter(item=>
                Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD"));
            setOutPutData(filtered)
        }

    };


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <h2 className="card-title">
                                Les Frets reçus : <b className="text-primary">{paginatedFrets ? paginatedFrets.length : 0} </b>
                                {/*Fret | {total ? (<><b className="text-success">{calculTotalFret(paginatedFrets)}</b> CDF</>):(<>0 CDF</>)}*/}
                            </h2>

                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <div className="form-group mt-3">
                                        <label htmlFor="ByAll" className="text-dark">
                                            Recherche par expediteur ou destinataire
                                        </label>
                                        <input type="text"
                                               onChange={handleSearch}
                                               value={search}
                                               name="ByAll"
                                               id="ByAll"
                                               className="form-control"
                                               placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group mt-3">
                                        <label htmlFor="ByAll" className="text-dark">
                                            Date debut
                                        </label>
                                        <input type="date" onChange={handleStartedDate} value={startAt}
                                               name="startDate" id="startDate" className="form-control" placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group mt-3">
                                        <label htmlFor="endDate" className="text-dark">
                                            Date fin
                                        </label>
                                        <input type="date" onChange={handleEndedDate} value={endAt}
                                               name="endDate" id="endDate" className="form-control" placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-3">
                                        <label htmlFor="filter" className="text-dark">.</label>
                                        <input type="button" onClick={handleBtns} value="Filtrer"
                                               name="filter" id="filter" className="form-control btn btn-dark" placeholder="Filtrer ..."
                                        />
                                    </div>
                                </div>
                            </div>

                            <table className="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th scope="col">N°</th>
                                    <th scope="col">Colis</th>
                                    <th scope="col">Code</th>
                                    <th scope="col">Nbre</th>
                                    <th scope="col">Emb</th>
                                    <th scope="col">Reste</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Exp</th>
                                    <th scope="col">Origine</th>
                                    <th scope="col">Dest</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Options</th>
                                </tr>
                                </thead>
                                {!loading && <tbody>
                                {paginatedFrets.map((item) => (
                                    <tr key={item.id}>
                                        <th scope="row">{counter++}</th>
                                        <td>{item.name}</td>
                                        <td><b>{item.fret.code}</b></td>
                                        <td><b className="text-primary text-center">{item.weight}</b></td>
                                        <td><b className="text-success text-center">{(item.weight) - (item.code)}</b></td>
                                        <td><b className="text-danger text-center">{item.code}</b></td>
                                        <td>{
                                            item.delivery === 2 ? (<b className="badge text-bg-success">Tout a été livré</b>)
                                                : item.delivery === 1 ? (<b className="badge text-bg-primary">Une partie a été livré</b>) :
                                                (<b className="badge text-bg-info">à livrer</b>)
                                        }</td>
                                        <td>{item.fret.customer}, <br/>{item.fret.phone}</td>
                                        <td>{item.fret.city_from}</td>
                                        <td>{item.fret.recipient}, <br/>{item.fret.rec_phone}</td>
                                        <td>{Moment(item.fret.created_at).format("DD/MM/YYYY")}</td>
                                        <td>
                                            <div className="input-group">
                                                <button
                                                    onClick={() => {
                                                        if (window.confirm('Etes-vous sûr(e) de vouloir effectuer cette action ?')) {
                                                            handleDeliveryFret(item.id)
                                                        }
                                                    }}
                                                    className="btn btn-sm btn-success">
                                                    Livrer
                                                </button>

                                            </div>
                                        </td>
                                    </tr>
                                ))
                                }

                                </tbody>}
                            </table>
                        </div>
                        {loading && <TableLoader width={300} height={350} />}

                        {itemsPerPage < filteredFrets.length &&
                        <Pagination
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            length={filteredFrets.length}
                            onPageChange={handleChangeCurrentPage}
                        />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReceivedFret;
